import { render, staticRenderFns } from "./Tillminkarafiende.vue?vue&type=template&id=978603ee"
import script from "./Tillminkarafiende.vue?vue&type=script&lang=js"
export * from "./Tillminkarafiende.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports